import { useEffect, useState } from "react";
import axios from "axios";
import { CalendarRange, Inbox } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Tile = ({ id, label, value, sub }) => (
  <div className="tacc-card p-4 md:p-5 min-w-0" data-testid={`digest-${id}`}>
    <div className="font-mono text-[9px] tracking-[0.25em] uppercase text-[#78716C] truncate">{label}</div>
    <div className="font-display text-3xl md:text-4xl text-[#1C1917] leading-none mt-2">{value}</div>
    {sub ? <div className="font-mono text-[9px] tracking-[0.15em] uppercase text-[#B45309] mt-2 truncate">{sub}</div> : null}
  </div>
);

export const DigestStrip = ({ onOpenQuote }) => {
  const [d, setD] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/digest/preview`).then((r) => setD(r.data)).catch(() => setD(null));
  }, []);

  if (!d) return null;
  const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  const leads = d.leads_waiting || [];

  return (
    <section className="mb-10" data-testid="admin-digest-strip">
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <CalendarRange size={14} className="text-[#B45309]" />
        <div className="section-tag">§ Last 7 days — what Monday's digest will say</div>
        <span className="font-mono text-[9px] tracking-[0.2em] uppercase text-[#555]">{d.since?.slice(0, 10)} → {d.until?.slice(0, 10)}</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
        <Tile id="signups" label="Sign-ups" value={d.signups} sub={`${d.signups_confirmed} confirmed`} />
        <Tile id="purchases" label="Purchases" value={d.purchases} sub={`${money(d.revenue)}${d.purchases_waiting ? ` · ${d.purchases_waiting} waiting` : ""}`} />
        <Tile id="grounded" label="Grounded" value={d.grounded_members} sub="members this week" />
        <Tile id="streak" label="Longest streak" value={d.longest_live_streak} sub={`${d.streaks_7_plus} at 7+`} />
        <Tile id="graduations" label="Graduations" value={d.graduations} sub={`${d.graduates_total} all-time`} />
        <Tile id="quotes" label="B2B quotes" value={d.b2b_quotes} sub="requests" />
      </div>
      <div className="tacc-card mt-3 px-4 md:px-5 py-4 flex flex-col md:flex-row md:items-center gap-3 md:gap-6" data-testid="digest-leads">
        <div className="flex items-center gap-2 shrink-0">
          <Inbox size={13} className="text-[#B45309]" />
          <span className="font-mono text-[9px] tracking-[0.25em] uppercase text-[#78716C]">Leads waiting for a reply</span>
          <span className="font-mono text-[9px] tracking-[0.2em] uppercase text-[#B45309]" data-testid="digest-leads-open">{d.leads_open_total ?? 0} open</span>
        </div>
        {leads.length === 0 ? (
          <span className="text-xs text-[#555]" data-testid="digest-leads-empty">Clean slate — nothing waiting.</span>
        ) : (
          <div className="flex flex-wrap gap-2">
            {leads.map((l, i) => (
              <button key={l.id} onClick={() => onOpenQuote?.(l.id)} className="group border border-[#E7DFD5] hover:border-[#F59E0B]/50 px-3 py-2 text-left transition-colors" data-testid={`digest-lead-${i}`} title="Open this quote">
                <div className="text-sm text-[#1C1917] group-hover:text-[#B45309] transition-colors">{l.company_name}</div>
                <div className="font-mono text-[9px] tracking-[0.15em] uppercase text-[#A8A29E]">
                  {[l.contact_name, l.company_size ? `${l.company_size} people` : null, l.tier, l.days_waiting != null ? `${l.days_waiting}d waiting` : null].filter(Boolean).join(" · ")}
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
